
import React, { Component } from 'react';
import { connect } from 'react-redux';
import assign from 'lodash/assign';
import get from 'lodash/get';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import {
    sagas as sagasMap
} from '../../map';
import { sagas as sagasMapMultiScene, MapMultiScene } from '../../mapmultiscene';
import { sagas as sagasMultiScene } from '../../multiscene';
import { sagas as sagasMeasurement } from '../../measurement';
import appGetActions from '../../app/saga';
import { getMapLayers } from '../../project';
import getAppModules from './getAppModules';
import DialogObjectInfo from './DialogObjectInfo';

/**
 * Viewer containing 2D map window and 3D scene window.
 *
 * @reactProps {Object} projectDefinition - project definition
 * @reactProps {Object} appLayoutProps - properties for customize layout
 * @reactProps {Object} map - actual map state
 */
class MapMultiSceneBasicViewer extends Component {

    classNames = mergeStyleSets({
        mapMultiScene: {
            borderLeft: '1px solid #cccccc',
            borderRight: '1px solid #cccccc'
        }
    });

    constructor(props) {
        super(props);
        this._mapMultiSceneComponent = null;
    }

    getAppModules() {
        return getAppModules(this.props.projectDefinition);
    }

    getLayout() {
        let layout = get(this.props, 'projectDefinition.app.layout', null);
        if (!layout) {
            layout = get(this.props, 'layout', {});
        }
        assign(layout, this.props.appLayoutProps);
        return layout;
    }

    getLayoutValue(name, defaultValue) {
        let layout = this.getLayout();
        return get(layout, name, defaultValue);
    }

    getLayoutValues() {
        return {
            multiScenePanelPosition: this.getLayoutValue('multiScenePanelPosition', 'left'),
            useStandaloneScene: this.getLayoutValue('useStandaloneScene', false)
        }
    }

    handleChangeView = (center, zoom, rotation, resolution) => {
        this.props.mapActions.changeView(center, zoom, rotation, resolution);
    }

    handleObjectInfo = async (layerId, attributes) => {
        await DialogObjectInfo.show(
            getMapLayers(this.props.project),
            layerId,
            attributes,
            this.props.projectDefinition.app
        );
    }

    render() {
        return (
            <Stack horizontal styles={{root: {height: '100%'}}} tokens={{childrenGap: 10, padding: 5}}>
                {this.renderMapMultiScene(this.getLayoutValues())}
            </Stack>
        );
    }

    renderMapMultiScene(layoutValues) {
        return (
            <Stack.Item grow={1} className={this.classNames.mapMultiScene}>
                <MapMultiScene
                    ref={element => this._mapMultiSceneComponent = element}
                    appConfig={this.props.projectDefinition.app}
                    multiSceneProject={this.props.projectDefinition.multiSceneProject}
                    map={this.props.map}
                    layers={this.props.map.layers}
                    groups={this.props.map.groups}
                    mapMultiScene={this.props.mapMultiScene}
                    multiScene={this.props.multiScene}
                    layoutValues={layoutValues}
                    onChangeView={this.handleChangeView}
                    onObjectInfo={this.handleObjectInfo}
                    mapMultiSceneActions={this.props.mapMultiSceneActions}
                    multiSceneActions={this.props.multiSceneActions}
                    mapActions={this.props.mapActions}
                    measurementActions={this.props.measurementActions}
                    urlParams={this.props.urlParams}
                    project={this.props.project}
                />
            </Stack.Item>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        mapActions: sagasMap.getActions(dispatch),
        mapMultiSceneActions: sagasMapMultiScene.getActions(dispatch),
        multiSceneActions: sagasMultiScene.getActions(dispatch),
        measurementActions: sagasMeasurement.getActions(dispatch),
        appActions: appGetActions(dispatch)
    };
}

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        auth: state.auth,
        uiValues: state.app.uiValues,
        urlParams: state.app.urlParams,
        mapMultiScene: state.mapMultiScene.mapMultiScene,
        multiScene: state.multiScene.multiScene,
        measurement: state.measurement,
        project: state.project
    };
}

const ConnectedMapMultiSceneBasicViewer = connect(mapStateToProps, mapDispatchToProps)(MapMultiSceneBasicViewer);

export default ConnectedMapMultiSceneBasicViewer;
